import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import CalculatedCommon from '../../../CommonV2/Calculated';

/**
 * FieldCalculated
 * @param {*} param0
 */
const FieldCalculated = ({
  componentCommon,
  code,
  disabled,
  existError,
  showError,
  validate,
  handleBlur,
  placeholder,
  param,
}) => (
  <Field
    component={CalculatedCommon}
    componentCommon={componentCommon}
    name={code}
    disabled={disabled}
    existError={existError}
    showError={showError}
    validate={validate}
    eventEmitter={v => handleBlur(v)}
    placeholder={placeholder}
    param={param}
  />
);

FieldCalculated.propTypes = {
  componentCommon: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  param: PropTypes.shape({
    constant: PropTypes.number,
    operator: PropTypes.string,
    min: PropTypes.string,
    max: PropTypes.string,
    thousandSeparator: PropTypes.string,
    decimalSeparator: PropTypes.string,
    selection: PropTypes.array,
  }),
};

FieldCalculated.defaultProps = {
  disabled: false,
  placeholder: undefined,
  param: {},
};

export default connect(FieldCalculated);
